import React from 'react'
import Classes from './SectionCards.module.css'
import { motion } from 'framer-motion'
import RevenueChart from './Comp/ColumnChart';
import Table from './Comp/Table/Table';

const FieldTypes = {
    TEXT: 'text',
    EMAIL: 'email',
    PASSWORD: 'password',
    NUMBER: 'number',
    TEXTAREA: 'textarea',
    PHONE: 'phone',
    ADDRESS: 'address',
    OPT_IN: 'opt-in'
};

const FieldComponent = ({ type, label, onDragStart }) => (
    <div className={Classes.flexCol1}>
        <div
            className={Classes.selectBox}
        >
            <h5>{label}</h5>
        </div>
    </div>
);

export default function SectionCards() {
    return (
        <div id='howItWorks' className={Classes.hero} >
            <h1 className={Classes.subheading}> Customize and automate your onboarding <br />
                and client management </h1>
            <p className={Classes.text}>
                Manage clients, projects, tasks, invoices, payments, and communication all in one platform.
            </p>

            <div className={Classes.cardsCon} >
                <div className={Classes.card} >
                    <div className={Classes.cardHeader} style={{ justifyContent: 'start' }} >
                        <div>
                            <h5 className={Classes.titleLight} >Revenue</h5>
                            <h3> $9,452 </h3>
                            <RevenueChart />
                        </div>
                    </div>
                    <div className={Classes.cardBody} >
                        <h3>Robust analytics</h3>
                        <h5>Leverage powerful analytics to optimize performance, streamline operations, and scale with new and existing clients.</h5>
                    </div>
                </div>
                <div className={Classes.card} >
                    <div className={Classes.cardHeader} >
                        <div className={Classes.flexColGroup}>
                            <FieldComponent
                                type={FieldTypes.TEXT}
                                label="Name"
                            />
                            <FieldComponent
                                type={FieldTypes.EMAIL}
                                label="Email"
                            />
                        </div>
                        <div className={Classes.flexColGroup}>
                            <FieldComponent
                                type={FieldTypes.PASSWORD}
                                label="Password"
                            />
                            <FieldComponent
                                type={FieldTypes.ADDRESS}
                                label="Address"
                            />
                        </div>
                        <div className={Classes.flexColGroup}>
                            <FieldComponent
                                type={FieldTypes.PHONE}
                                label="Phone"
                            />
                            <FieldComponent
                                type={FieldTypes.OPT_IN}
                                label="Email Opt-in"
                            />
                        </div>
                        <div className={Classes.flexColGroup}>
                            <FieldComponent
                                type={FieldTypes.TEXT}
                                label="Name"
                            />
                            <FieldComponent
                                type={FieldTypes.EMAIL}
                                label="Email"
                            />
                        </div>
                        <div className={Classes.flexColGroup}>
                            <FieldComponent
                                type={FieldTypes.PASSWORD}
                                label="Password"
                            />
                            <FieldComponent
                                type={FieldTypes.ADDRESS}
                                label="Address"
                            />
                        </div>
                        <div className={Classes.flexColGroup}>
                            <FieldComponent
                                type={FieldTypes.PHONE}
                                label="Phone"
                            />
                            <FieldComponent
                                type={FieldTypes.OPT_IN}
                                label="Email Opt-in"
                            />
                        </div>
                    </div>
                    <div className={Classes.cardBody} >
                        <h3>Custom forms for onboarding</h3>
                        <h5>Streamline onboarding for your clients with a custom form builder tailored to your agency and services.</h5>
                    </div>
                </div>
                <div className={Classes.card} >
                    <div className={Classes.cardHeader} style={{ justifyContent: 'start' }} >
                        <div className={Classes.profileCon} >
                            <div className={Classes.profileCard} >
                                <div className={Classes.card_img} >
                                    <img src={'/assets/images/profile.png'} className={Classes.card_inner_img} />
                                </div>
                                <div>
                                    <h5 className={Classes.titleLight} >Anchorize.io</h5>
                                    <div className={'flexAlign10'} >
                                        <h5 className={Classes.miniTitle} >John Smith</h5>
                                        <h5 className={Classes.greenCard} >$1.000</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <Table />
                        </div>
                    </div>
                    <div className={Classes.cardBody} >
                        <h3>Complete client management</h3>
                        <h5>Effortlessly manage your clients with order tracking, invoicing, payments, and customized onboarding flows.</h5>
                    </div>
                </div>
            </div>

            <motion.div
                whileTap={{ scale: 0.97 }}
                whileHover={{ scale: 1.03 }}
            >
                <button className={Classes.startBtn} > <h5>Get started for free</h5> </button>
            </motion.div>
            <div className={Classes.text} style={{ margin: '0', fontSize: '14px' }} > No credit card required </div>
        </div>
    )
}
